/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createArg } from '../../factoriesAny.js';
export var argDependencies = {
  typedDependencies,
  createArg
};